module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.3e5675c89f974f7811ee.woff";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Regular-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular-webfont.woff
// module chunks = 2